<script>
export default {
  name: 'nowebgl',
  components: {

  },
    data: () => ({
      windowSize: {
        x: 0,
        y: 0,
      },
    }),
    computed: {
        webglfallbackUrl () {
            return (process.env.BASE_URL + 'assets/nowebgl-fallback.jpg')
        },
        imgheight () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return '240'
                case 'sm': return '400'
                case 'md': return '480'
                case 'lg': return '480'
                case 'xl': return '480'
                default: return '400'
            }
        },
        cols () {
            if (this.windowSize.x/this.windowSize.y > 2 && this.$vuetify.breakpoint.smAndDown) {
                return [8,4]
            } else if (this.windowSize.x/this.windowSize.y > 1.5 && this.$vuetify.breakpoint.smAndDown) {
                return [6,6]
            } else {
                return [12,12]
            }
        }
  },

  methods: {
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      },      
  },
  mounted () {
      this.onResize()
  }
}
</script>

<template>
<v-sheet class="nowebgl">
    <v-row
        class="fill-height"
        v-resize="onResize"
    >
        <v-col
            :cols="cols[0]"
        >
            <v-col
                class="headline font-weight-light text-center"
                cols="12"
            >
                No webgl supported in this browser
            </v-col>
            <v-col
                class="font-weight-light text-center"
                cols="12"
            >
                It's not possible to show a realtime 4D visualisation of land subsidence in the Ho Chi Minh City area. Please try a different browser, or visit <a href="https://browserleaks.com/webgl">browserleaks.com/webgl</a> to check your browser's capabilities.
            </v-col>
        </v-col>
        <v-col 
            :cols="cols[1]"
        >
            <v-img
                :src="webglfallbackUrl"
                contain
                class="ma-2"
                :max-height="imgheight"
            >
            </v-img>        
        </v-col>
    </v-row>
</v-sheet>
</template>

<style lang="scss" scoped>
.nowebgl {
  overflow: hidden;
  position: absolute;
  z-index:3;
  height: 100%;
  width: 100%;
}
</style>
